import { EEstimationTargets, EMyHomeEstimationTargets } from '@cian/valuation-main-filters-widget';
import { ca } from '@cian/analytics';

export const caMyHomeEventCategories: { [K in EMyHomeEstimationTargets]: string } = {
  [EEstimationTargets.flat]: 'MyHomeFlat',
  [EEstimationTargets.house]: 'MyHomeHouse',
  [EEstimationTargets.land]: 'MyHomeLand',
};

export function trackAddNewCard(estimationTarget: EMyHomeEstimationTargets) {
  ca('eventSite', {
    name: 'oldevent',
    category: caMyHomeEventCategories[estimationTarget],
    action: 'Click',
    label: 'EstateCalculator',
  });
}
